export class Settings {
    private static backendBaseUrl: string = import.meta.env.VITE_BACKEND_BASE_URL as string;
    private static clientId: string = import.meta.env.VITE_CLIENT_ID as string;
    private static redirectUri: string = import.meta.env.VITE_REDIRECT_URI as string;
    private static postLogoutRedirectUri: string = import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI as string;
    private static sentryDsn: string = import.meta.env.VITE_SENTRY_DSN as string;
    private static environment: string = import.meta.env.VITE_ENVIRONMENT as string;

    public static getEnvironment(): string {
        return Settings.environment;
    }

    public static getSentryDsn(): string {
        return Settings.sentryDsn as string;
    }

    public static getBackendBaseUrl(): string {
        return Settings.backendBaseUrl as string;
    }

    public static getClientId(): string {
        return Settings.clientId as string;
    }

    public static getRedirectUri(): string {
        return Settings.redirectUri as string;
    }

    public static getPostLogoutRedirectUri(): string {
        return Settings.postLogoutRedirectUri as string;
    }

    public static getStorageKeyPrefixOidc():string{
        return `csm-portal-`;
    }
}
